__turbopack_context__.v({
  "root": "AccordionBlok-module__YEMR7G__root",
});
